import { render, staticRenderFns } from "./SelectForm.vue?vue&type=template&id=d2bb32ac"
import script from "./SelectForm.vue?vue&type=script&lang=js"
export * from "./SelectForm.vue?vue&type=script&lang=js"
import style0 from "./SelectForm.vue?vue&type=style&index=0&id=d2bb32ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports